import { Component, OnInit, ViewChild , AfterViewInit, OnDestroy } from '@angular/core';
import { ContractorsService } from '..';
import { GLOBAL } from 'src/app/app.globals';
import { formatMoment } from 'ngx-bootstrap/chronos/format';
import { NgForm } from '@angular/forms';
import { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/core/services';
import { stringify } from 'querystring';
import { stripSummaryForJitNameSuffix } from '@angular/compiler/src/aot/util';
@Component({
  selector: 'app-create-contractor',
  templateUrl: './create-contractor.component.html',
  styleUrls: ['./create-contractor.component.css']
})

export class CreateContractorComponent implements OnInit {
  @ViewChild('contractorForm') contractorForm: NgForm;
  @ViewChild('dialogerror') public dialogerror: SwalComponent;
  public alertOption: SweetAlertOptions = {};
  btnsave: boolean;
  btnsavenexit: boolean;
  company: any;
  shortCode: any;
  email: any;
  pANNo: any;
  mobileNo: number;
  contractorCode:number;
  private lastCheckedCompany: string = '';
  private lastCheckedShortCode: string = '';
  constructor(private contractorsService: ContractorsService,
    private logHelperService: LogHelperService,   public sharedService: SharedService,
    private router: Router) { }
  ngOnInit() {
  }

onSubmit(formData, shouldNavigate: boolean = false) {

    const contractor: any = {
      ContractorVendor_Code: 0,
      Company: formData.Company,
      ShortCode:formData.ShortCode,
      EmailID: formData.EmailID,
      PhoneNo: formData.PhoneNo,
      FullName:formData.FullName,
      PANNo:formData.PANNo,
      AltEmailID  :formData.AltEmailID,
      MobileNo:formData.MobileNo,
      AltMobileNo:formData.AltMobileNo,
      Designation:formData.Designation,
      CreateBy: GLOBAL.USER_ID,
      RoleCode: GLOBAL.ROLE,
      EntityComplianceInfos: [],
    };
    if (formData.gstdetail === true) {
      const entityComplianceInfo: any = {};
      entityComplianceInfo.ShortCode = 'CCLRA1003';
      entityComplianceInfo.RegistrationNumber = formData.epfcode;
      entityComplianceInfo.Other1 = formData.gstregistrationno;
      entityComplianceInfo.Other2 = formData.companyregistrationno;
      contractor.EntityComplianceInfos.push(entityComplianceInfo);
    }
    const uploadParams = {
      contractorvendor_code: ''
    };

    // 3. Perform the navigation INSIDE the subscribe block
    this.contractorsService.addNewContractor(contractor).subscribe((result: any) => {
      
      uploadParams.contractorvendor_code = result.Data;

      this.logHelperService.logSuccess({
        message: 'Contractor addded successfully'
      });

      // CHECK HERE: If this was a "Save" click, navigate now.
      if (shouldNavigate) {
         this.router.navigate(['contractor/contractors']);
      } 
      // If this was "Save and New", just clear the form.
      else {
         this.clearForm();
      }

    }, error => {
        // Handle error here (optional but recommended)
        this.logHelperService.logError({
            message: 'Failed to add contractor'
        });
    });
  }  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit(): void {
    this.contractorForm.reset();
  }
  clearForm() {
    this.contractorForm.reset();
    this.lastCheckedCompany = ''; // Reset the last checked value
    this.lastCheckedShortCode = ''; // Reset the last checked value
  }
  async onCancel() {
    this.router.navigate(['contractor/contractors']);
  }
  saveAndNew() {

    // tslint:disable-next-line: triple-equals
    if (this.contractorForm.controls.Company.valid
      && this.contractorForm.controls.ShortCode.valid
      && this.contractorForm.controls.FullName.valid
      && this.contractorForm.controls.EmailID.valid
      && this.contractorForm.controls.MobileNo.valid
      && this.contractorForm.controls.PANNo.valid) {
      this.onSubmit(this.contractorForm.value, false);
          }
    else {
      this.logHelperService.logError({
        message: 'Please Fill Form Properly'
      });
    }
  }

  save() {

    // tslint:disable-next-line: triple-equals
    if (this.contractorForm.controls.Company.valid
      && this.contractorForm.controls.ShortCode.valid
      && this.contractorForm.controls.FullName.valid
      && this.contractorForm.controls.EmailID.valid
      && this.contractorForm.controls.MobileNo.valid
      && this.contractorForm.controls.PANNo.valid) {
      
      // Pass TRUE so it navigates away upon success
      this.onSubmit(this.contractorForm.value, true); 
      
      // REMOVED: this.router.navigate(...) from here
      // REMOVED: this.clearForm() from here
    }
    else {
      this.logHelperService.logError({
        message: 'Please Fill Form Properly'
      });
    }
  }

  // tslint:disable-next-line: function-name
  CheckCompany() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const companyCtrl = this.contractorForm.controls['Company'];
    const currentCompany = companyCtrl.value;

    // Don't call API if field is empty or value hasn't changed
    if (!currentCompany || currentCompany.trim() === '' || currentCompany === this.lastCheckedCompany) {
      return true;
    }

    // Update the last checked value
    this.lastCheckedCompany = currentCompany;

    this.contractorsService
      .checkCompany(currentCompany, this.contractorCode)
      .subscribe((res: any) => {
        this.company = res.Data;

        if (this.company > 0) {
          this.logHelperService.logError({
            message:
              'This field requires a unique entry. This Firm / Company name has already been used. Please enter a different input.'
          });

          companyCtrl.reset();
          this.lastCheckedCompany = ''; // Reset since we cleared the field
        }
      });

    return true;
  }
  // tslint:disable-next-line: function-name
  CheckShort() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const shortCodeCtrl = this.contractorForm.controls['ShortCode'];
    const currentShortCode = shortCodeCtrl.value;

    // Don't call API if field is empty or value hasn't changed
    if (!currentShortCode || currentShortCode.trim() === '' || currentShortCode === this.lastCheckedShortCode) {
      return true;
    }

    // Update the last checked value
    this.lastCheckedShortCode = currentShortCode;

    this.contractorsService
      .checkShortCode(currentShortCode, this.contractorCode)
      .subscribe((res: any) => {
        this.shortCode = res.Data;

        if (this.shortCode > 0) {
          this.logHelperService.logError({
            message:
              'This field requires a unique entry. This Vendor code has already been used with another Firm / Company. Please enter a different vendor code.'
          });

          shortCodeCtrl.reset();
          this.lastCheckedShortCode = ''; // Reset since we cleared the field
        }
      });

    return true;
  }
  // tslint:disable-next-line: function-name

  CheckEmail() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const emailControl = this.contractorForm.controls['EmailID'];
    const altEmailControl = this.contractorForm.controls['AltEmailID'];

    if (!emailControl || !emailControl.value) {
      return true;
    }

    if (emailControl.invalid) {
      this.logHelperService.logError({
        message: 'Please enter a valid email address.'
      });

      emailControl.reset();
      return true;
    }

    if (
      altEmailControl.value &&
      emailControl.value.trim() === altEmailControl.value.trim()
    ) {
      this.logHelperService.logError({
        message: 'Email ID and Alternate Email ID should not be the same.'
      });

      emailControl.reset();
      return true;
    }

    this.contractorsService
      .checkEmail(emailControl.value, this.contractorCode)
      .subscribe((res: any) => {
        this.email = res.Data;

        if (this.email > 0) {
          this.logHelperService.logError({
            message:
              'Email address already taken for another company. Please use a different email ID.'
          });

          emailControl.reset();
        }
      });

    return true;
  }
  // tslint:disable-next-line: function-name
  CheckPanCardNo() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const panCtrl = this.contractorForm.controls['PANNo'];

    if (
      !panCtrl ||
      !panCtrl.value ||
      panCtrl.value.toString().trim() === ''
    ) {
      return true;
    }

    if (panCtrl.invalid) {
      return true;
    }

    this.contractorsService
      .checkPanCard(panCtrl.value, this.contractorCode)
      .subscribe((res: any) => {
        this.pANNo = res.Data;

        if (this.pANNo > 0) {
          this.logHelperService.logError({
            message:
              'This field requires a unique entry. This PAN number has been used for another Firm / Company. Please enter a different input.'
          });

          panCtrl.reset();
        }
      });

    return true;
  }
  checkAlternateEmailID() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const emailControl = this.contractorForm.controls['EmailID'];
    const altEmailControl = this.contractorForm.controls['AltEmailID'];

    if (!altEmailControl || !altEmailControl.value) {
      return true;
    }

    if (altEmailControl.invalid) {
      this.logHelperService.logError({
        message: 'Please enter a valid email address.'
      });

      altEmailControl.reset();
      return true;
    }

    if (
      emailControl.value &&
      emailControl.value.trim() === altEmailControl.value.trim()
    ) {
      this.logHelperService.logError({
        message: 'Email ID and Alternate Email ID should not be the same.'
      });

      altEmailControl.reset();
    }

    return true;
  }
  checkAlternateMobileNo() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const mobileCtrl = this.contractorForm.controls['MobileNo'];
    const altCtrl = this.contractorForm.controls['AltMobileNo'];

    // Do nothing if values are missing
    if (!mobileCtrl.value || !altCtrl.value) {
      return true;
    }

    const mobile = mobileCtrl.value.toString().trim();
    const altMobile = altCtrl.value.toString().trim();

    if (mobile !== '' && altMobile !== '' && mobile === altMobile) {
      this.logHelperService.logError({
        message: 'Mobile No and Alternate Mobile No should not be the same.'
      });

      altCtrl.reset();
      return false;
    }

    return true;
  }
  checkMobileNo() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const mobileCtrl = this.contractorForm.controls['MobileNo'];

    if (!mobileCtrl.value || mobileCtrl.value.toString().trim() === '') {
      return true;
    }

    this.checkAlternateMobileNo();

    if (mobileCtrl.invalid) {
      return true;
    }

    this.contractorsService
      .checkMobileNO(mobileCtrl.value, this.contractorCode)
      .subscribe((res: any) => {
        this.mobileNo = res.Data;

        if (this.mobileNo > 0) {
          this.logHelperService.logError({
            message:
              'This field requires a unique entry. This Mobile No has been used for another Firm / Company. Please enter a different input.'
          });

          mobileCtrl.reset();
        }
      });

    return true;
  }
}
